var simplemaps_usmap_mapdata = {
    main_settings: {
        width: "responsive",
        background_color: "#EFEFEF",
        background_transparent: "yes",
        border_color: "#ffffff",
        popups: "detect",
        state_description: "",
        state_color: "#9ECCE3",
        state_hover_color: "#3B729F",
        state_url: "",
        border_size: 0.5,
        all_states_inactive: "no",
        all_states_zoomable: "no",
        location_description: "",
        location_color: "#FF0067",
        location_opacity: 0.8,
        location_hover_opacity: 1,
        location_url: "",
        location_size: 90,
        location_type: "image",
        location_image_source: "",
        location_border_color: "#FFFFFF",
        location_border: 2,
        location_hover_border: 2.5,
        all_locations_inactive: "no",
        all_locations_hidden: "no",
        label_color: "#d5ddec",
        label_hover_color: "#d5ddec",
        label_size: 22,
        label_font: "Arial",
        hide_labels: "yes",
        hide_eastern_labels: "no",
        zoom: "yes",
        back_image: "no",
        arrow_color: "#3B729F",
        arrow_color_border: "#88A4BC",
        initial_back: "no",
        initial_zoom: -1,
        initial_zoom_solo: "no",
        region_opacity: 1,
        region_hover_opacity: 0.6,
        zoom_out_incrementally: "yes",
        zoom_percentage: 0.99,
        zoom_time: 0.5,
        popup_color: "white",
        popup_opacity: 0.9,
        popup_shadow: 1,
        popup_corners: 5,
        popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
        popup_nocss: "no",
        div: "map",
        auto_load: "no",
        url_new_tab: "no",
        images_directory: "default",
        fade_time: 0.1,
        link_text: "(Link)",
    },
    state_specific: {
        HI: { name: "Hawaii", description: "default", color: "default", hover_color: "default", url: "default", hide: "yes" },
        AK: { name: "Alaska", description: "default", color: "default", hover_color: "default", url: "default", hide: "yes" },
        FL: { name: "Florida", description: "default", color: "default", hover_color: "default", url: "default", inactive: "no" },
        NH: { name: "New Hampshire", description: "default", color: "default", hover_color: "default", url: "default" },
        VT: { name: "Vermont", description: "default", color: "default", hover_color: "default", url: "default" },
        ME: { name: "Maine", description: "default", color: "default", hover_color: "default", url: "default" },
        RI: { name: "Rhode Island", description: "default", color: "default", hover_color: "default", url: "default" },
        NY: { name: "New York", description: "default", color: "default", hover_color: "default", url: "default" },
        PA: { name: "Pennsylvania", description: "default", color: "default", hover_color: "default", url: "default" },
        NJ: { name: "New Jersey", description: "default", color: "default", hover_color: "default", url: "default" },
        DE: { name: "Delaware", description: "default", color: "default", hover_color: "default", url: "default" },
        MD: { name: "Maryland", description: "default", color: "default", hover_color: "default", url: "default" },
        VA: { name: "Virginia", description: "default", color: "default", hover_color: "default", url: "default" },
        WV: { name: "West Virginia", description: "default", color: "default", hover_color: "default", url: "default" },
        OH: { name: "Ohio", description: "default", color: "default", hover_color: "default", url: "default" },
        IN: { name: "Indiana", description: "default", color: "default", hover_color: "default", url: "default" },
        IL: { name: "Illinois", description: "default", color: "default", hover_color: "default", url: "default" },
        CT: { name: "Connecticut", description: "default", color: "default", hover_color: "default", url: "default" },
        WI: { name: "Wisconsin", description: "default", color: "default", hover_color: "default", url: "default" },
        NC: { name: "North Carolina", description: "default", color: "default", hover_color: "default", url: "default" },
        DC: { name: "District of Columbia", description: "default", color: "default", hover_color: "default", url: "default" },
        MA: { name: "Massachusetts", description: "default", color: "default", hover_color: "default", url: "default" },
        TN: { name: "Tennessee", description: "default", color: "default", hover_color: "default", url: "default" },
        AR: { name: "Arkansas", description: "default", color: "default", hover_color: "default", url: "default" },
        MO: { name: "Missouri", description: "default", color: "default", hover_color: "default", url: "default" },
        GA: { name: "Georgia", description: "default", color: "default", hover_color: "default", url: "default" },
        SC: { name: "South Carolina", description: "default", color: "default", hover_color: "default", url: "default" },
        KY: { name: "Kentucky", description: "default", color: "default", zoomable: "no", hover_color: "default", url: "default" },
        AL: { name: "Alabama", description: "default", color: "default", hover_color: "default", url: "default" },
        LA: { name: "Louisiana", description: "default", color: "default", hover_color: "default", url: "default" },
        MS: { name: "Mississippi", description: "default", color: "default", hover_color: "default", url: "default" },
        IA: { name: "Iowa", description: "default", color: "default", hover_color: "default", url: "default" },
        MN: { name: "Minnesota", description: "default", color: "default", hover_color: "default", url: "default" },
        OK: { name: "Oklahoma", description: "default", color: "default", hover_color: "default", url: "default" },
        TX: { name: "Texas", description: "default", color: "default", hover_color: "default", url: "default" },
        NM: { name: "New Mexico", description: "default", color: "default", hover_color: "default", url: "default" },
        KS: { name: "Kansas", description: "default", color: "default", hover_color: "default", url: "default" },
        NE: { name: "Nebraska", description: "default", color: "default", hover_color: "default", url: "default" },
        SD: { name: "South Dakota", description: "default", color: "default", hover_color: "default", url: "default" },
        ND: { name: "North Dakota", description: "default", color: "default", hover_color: "default", url: "default" },
        WY: { name: "Wyoming", description: "default", color: "default", hover_color: "default", url: "default" },
        MT: { name: "Montana", description: "default", color: "default", hover_color: "default", url: "default" },
        CO: { name: "Colorado", description: "default", color: "default", hover_color: "default", url: "default" },
        UT: { name: "Utah", description: "default", color: "default", hover_color: "default", url: "default" },
        AZ: { name: "Arizona", description: "default", color: "default", hover_color: "default", url: "default" },
        NV: { name: "Nevada", description: "default", color: "default", hover_color: "default", url: "default" },
        OR: { name: "Oregon", description: "default", color: "default", hover_color: "default", url: "default" },
        WA: { name: "Washington", description: "default", color: "default", hover_color: "default", url: "default" },
        CA: { name: "California", description: "default", color: "default", hover_color: "default", url: "default" },
        MI: { name: "Michigan", description: "default", color: "default", hover_color: "default", url: "default" },
        ID: { name: "Idaho", description: "default", color: "default", hover_color: "default", url: "default" },
        GU: { name: "Guam", description: "default", color: "default", hover_color: "default", url: "default", hide: "yes" },
        VI: { name: "Virgin Islands", description: "default", color: "default", hover_color: "default", url: "default", hide: "yes" },
        PR: { name: "Puerto Rico", description: "default", color: "default", hover_color: "default", url: "default", hide: "yes" },
        AS: { name: "American Samoa", description: "default", color: "default", hover_color: "default", url: "default", hide: "yes" },
        MP: { name: "Northern Mariana Islands", description: "default", color: "default", hover_color: "default", url: "default", hide: "yes" },
    },
    locations: {},
    labels: { HI: { color: "default", hover_color: "default", font_family: "default", pill: "yes", width: "default" } },
};